module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Layout/Layout-vertical-296d9d3169e2507f71082923fd267f2d.svg";